<template>
  <el-card>
    <div slot="header" class="clearfix">
      <span>嘉年华统计</span>
    </div>

    <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
      <el-form-item label="日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.startDate"
          type="date"
          size="mini"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.endDate"
          type="date"
          size="mini"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="类型" prop="endDate">
        <el-select
          v-model.number="queryParams.type"
          placeholder="请选择类型"
          size="small"
          @keyup.enter.native="handleQuery"
        >
          <el-option
            v-for="(item, index) in typeArr"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" :loading="loading" icon="el-icon-search" @click="handleQuery">查询</el-button>
        <el-button type="success" size="mini" :loading="loading" icon="el-icon-download" @click="exportData">导出</el-button>
      </el-form-item>
    </el-form>

    <el-table
      border
      :data="tableData"
      :default-expand-all="false"
      row-key="date"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      style="width: 100%;margin-bottom: 20px;"
    >

      <el-table-column
        prop="date"
        label="日期"
        align="center"
      />
      <el-table-column
        prop="user"
        label="参与人数"
        align="center"
      />
      <el-table-column
        label="每关参数人数"
        align="center"
      >
        <el-table-column
          v-for="(item, index) in 20"
          :key="index"
          :label="'关卡'+item"
          align="center"
        >
          <template scope="{row}">
            <span v-if="row.lv_join[item]"> {{ row.lv_join[item].user }}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="刷新 人数/次数"
        align="center"
      >
        <el-table-column
          prop="use"
          label="人数"
          align="center"
        >
          <template scope="{row}">
            <span v-if="row.refresh_user">{{ row.refresh_user.user }}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="count"
          label="次数"
          align="center"
        >
          <template scope="{row}">
            <span v-if="row.refresh_user">{{ row.refresh_user.count }}</span>
            <span v-else>0</span>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>

    <el-table
      border
      :data="tableData"
      :default-expand-all="false"
      row-key="date"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      style="width: 100%;margin-bottom: 20px;"
    >
      <el-table-column
        label="奖励兑换人数与次数"
        align="center"
      >
        <el-table-column
          v-for="(item, index) in [1,2,3,4,5,6,7,8,9]"
          :key="index"
          :label="'奖励'+item"
          align="center"
        >
          <el-table-column
            label="人数"
            align="center"
          >
            <template scope="{row}">
              <span v-if="row.reward_user[item]"> {{ row.reward_user[item].user }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>
          <el-table-column
            label="次数"
            align="center"
          >
            <template scope="{row}">
              <span v-if="row.reward_user[item]"> {{ row.reward_user[item].count }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>
        </el-table-column>

      </el-table-column>
    </el-table>

    <totalStat ref="ad" title="奖励兑换次数分布" />
    <totalStat ref="ad2" title="奖励兑换人数分布" />
  </el-card>
</template>

<script>
import { getCarnivalStat } from '@/api/statistics/user_remain'
import { getCacheQuery, getLastDates, setCacheQuery } from '@/utils'
import totalStat from '@/views/config/carnival-stat/components/echart.vue'

export default {
  name: 'CooperativeBuildStat',
  components: {
    totalStat
  },
  data() {
    return {
      loading: false,
      queryParams: {
        startDate: '',
        endDate: '',
        type: 0
      },
      typeArr: [{ label: '天', value: 0 }, { label: '总', value: 1 }],
      tableData: []
    }
  },
  created() {
    this.queryParams.startDate = getLastDates(7)
    this.queryParams.endDate = getLastDates(1)
    this.getTables(undefined)
  },
  methods: {
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      if (!this.queryParams.endDate) {
        this.msgError('请选择开始日期')
        return
      }
      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }
      this.getTables({})
    },
    getTables(event) {
      this.loading = true
      this.queryParams.level = 0
      this.tableData = []
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getCarnivalStat(this.queryParams).then(res => {
        setCacheQuery(this.$options.name, this.queryParams)
        this.loading = false
        this.tableData = res.data.data
        this.$refs.ad.refresh(this.tableData, 'count')
        this.$refs.ad2.refresh(this.tableData, 'user')
      })
    },
    exportData() {
      this.loading = true
      this.queryParams.level = 1
      getCarnivalStat(this.queryParams).then(res => {
        this.loading = false
        window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
      })
    }
  }

}
</script>

<style scoped>
.mtop{
  margin-top: 20px;
}
</style>
